import './bootstrap.js';

import * as bootstrap from 'bootstrap';

import '../laravel-cms/js/app.js'
import '../laravel-core/js/front/app.js'
import '../laravel-commerce/js/app.js'

import '../laravel-core/js/front/tarteaucitron/tarteaucitron.import.js';

import.meta.glob([
    '../medias/images/**/*.jpg',
    '../medias/images/**/*.png',
    '../medias/images/**/*.svg',
    '../fonts/**',
]);

import '../scss/app.scss';

// Code site

import './creative-menu/script.js';
import './creative-menu/style.css';

import './swiper/script.js'

import './bootstrap/bootstrap-input-spinner.js';

import '@fancyapps/fancybox/dist/jquery.fancybox.min.js';
import './jquery.fancybox/style.css';

import './jquery.counterup/jquery.counterup.min.js';

import './components/carte-france.js';

jQuery(function($) {
	//
	// js pour le compteur
	//
	const counterUp = window.counterUp.default;

	const callback = entries => {
		entries.forEach( entry => {
			const el = entry.target;

			if(entry.isIntersecting) {
				counterUp(el, {
					delay: 10,
					duration: 1000,
				});
			}
		} )
	}

	$('.compteur').each(function() {
		const IO = new IntersectionObserver(
			callback,
			{ threshold: 1 }
		);

		IO.observe(this);
	});


	//
	// js pour mettre à jour les input[type="number"]
	//
	// $('input[type="number"]').inputSpinner();


	//
	// js pour modifier le comportement par défaut de fancybox
	//
	$('[data-fancybox]').fancybox({
		animationEffect: 'zoom-in-out',
		backFocus: false,
		loop: true,
		transitionEffect: 'slide'
	});

	//
	// js pour empecher l'ajout de caractère non autorisé dans les input text inputmode decimal
	//
	// $('input[id^="qty_"]').each(function() {
	// 	const input = $(this);

	// 	input.on('input', function() {
	// 		input.val(input.val().replace(/[^0-9]/g, ''));

	// 		if (input.val() === '0' || input.val() === '') {
	// 			input.val('1');
	// 		}
	// 	});

	// 	input.on('change', function(event) {
	// 		event.preventDefault();

	// 		const value = parseInt(input.val(), 10);
	// 		if (isNaN(value) || value <= 0) {
	// 			input.val('1');
	// 		}
	// 	});
	// });
});

// Modification de l'affichage de la date/heure d'une commande vers une date/heure locale
document.querySelectorAll('.utc-date').forEach(el => {
    const utcDate = new Date(el.dataset.utc + 'Z');

    const day = String(utcDate.getDate()).padStart(2, '0');
    const month = String(utcDate.getMonth() + 1).padStart(2, '0');
    const year = utcDate.getFullYear();

    const hours = String(utcDate.getHours()).padStart(2, '0');
    const minutes = String(utcDate.getMinutes()).padStart(2, '0');

    el.textContent = `${day}/${month}/${year} à ${hours}:${minutes}`;
});

// Ajout de la touche Entrée pour effectuer la recherche
document.querySelector('form.ani-form.recherche').addEventListener('keypress', function(e) {
	if (e.key === 'Enter') {
		e.preventDefault();
		this.classList.add('was-validated')

		const input = this.querySelector('input[name="search"]');

		if (!input.value.trim()) {
			input.focus();
		}
		else {
			this.submit();
		}
	}
});